export async function getAmcCode(isGuest) {
  const email = isGuest ? process.env.REACT_APP_API_GUEST_EMAIL : process.env.REACT_APP_API_GUEST_EMAIL;
  const token = isGuest ? process.env.REACT_APP_API_GUEST_TOKEN : process.env.REACT_APP_API_GUEST_TOKEN;

  try {
    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/amc/get-amc-code-for-app?email=${encodeURIComponent(email)}`, {
      method: "GET",
      headers: {
        Authorization: token,
        // 'Content-Type': 'application/json'
      },
    });

    const data = await response.json();

    if (!response.ok || (data?.status !== 200) ) {
      throw new Error(data?.message);
    }

    // return await Promise.resolve(data?.data);

    return {
      error: false,
      data: data?.data
    }

    // return new Promise((res) => res(data?.data));
  } catch (error) {

    // return await Promise.reject(error?.message || "Failed to get AMC Code");

    return {
      error: true,
      data: null
    }

    return new Promise((_, rej) => rej(error?.message));
  }
}
